import { Text } from '@chakra-ui/react'
import { dateText, languageLinks, navigationBar } from './styles'
import { Link } from 'react-router-dom'

//dropdown fyrir ensku/íslensku

export function Navigation() {
    return (
        <nav style={navigationBar}>
            {/* <img src={logo} style={logoImg} /> */}
            <div style={dateText}>
                <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Text>ELÍSA & ØYVIND</Text>
                </Link>
            </div>
            <div style={languageLinks}>
                {/* <Text>
                    <Link onClick={() => changeLanguage("is")}>Íslenska</Link>
                    {'  |  '}
                    <Link onClick={() => changeLanguage("no")}>Norsk</Link>
                    {'  |  '}
                    <Link onClick={() => changeLanguage("en")}>English</Link>
                </Text> */}

            </div>

        </nav>
    )
}
